import {SET_SHOW_NEXT_BUTTON, SET_VISIBILITY, SET_HIDE_VALIDATION} from "./actionTypes";

export function setSurveyNavVisibility(visibility) {
  return {
    type: SET_VISIBILITY,
    visibility
  }
}

export function setSurveyNavShowNextButton(showNextButton) {
  return {
    type: SET_SHOW_NEXT_BUTTON,
    showNextButton
  }
}

export function setSurveyNavHideValidation(hideValidation) {
  return {
    type: SET_HIDE_VALIDATION,
    hideValidation
  }
}